import { vuexBase } from '@/store/composition/base'
import { deleteItem } from '@/api/defaultApi'
import setErrorString from '@/utils/store/setErrorString'

const createState = () => ({
  ...vuexBase.createState(),

  // для оповещения успеха или ошибки при удалении записей
  modalResponse: {
    isActive: false,
    title: '',
    text: '',
    type: 'main'
  },

  // для оповещения невозможности удаления ввиду использования item
  modalItemIsUsed: {
    isActive: false,
    title: 'Ошибка!',
    text: '',
    type: 'main'
  },

  // ключ по которому выводится свойство item при ошибке удаления
  deleteResponseKey: 'id',

  // item для проверки возможности удаления
  checkedDeleteItem: {},

  removeConfirmation: {
    active: false
  }
})

const createGetters = () => ({
  ...vuexBase.createGetters(),

  getModalResponse: state => state.modalResponse,
  getModalItemIsUsed: state => state.modalItemIsUsed,
  visibleRemoveConfirmation: (state) => state.removeConfirmation.active,
  getSearchValue: (state) => state.search,

  // для проверки возможности удаления item
  itemIsUsed: () => false
})

const createMutations = () => ({
  ...vuexBase.createMutations(),

  // modal response
  OPEN_MODAL_RESPONSE: (state, { text, title }) => {
    state.modalResponse = {
      type: 'main',
      isActive: true,
      text,
      title
    }
  },

  CLOSE_MODAL_RESPONSE: (state) => {
    state.modalResponse.isActive = false
    state.modalResponse.title = ''
    state.modalResponse.text = ''
  },

  // modal item is used
  OPEN_MODAL_ITEM_IS_USED: (state, text) => {
    state.modalItemIsUsed.isActive = true
    state.modalItemIsUsed.text = 'Данные записи используются и их невозможно удалить: ' + text
  },

  CLOSE_MODAL_ITEM_IS_USED: (state) => {
    state.modalItemIsUsed.isActive = false
    state.modalItemIsUsed.text = ''
  },

  SET_CHECKED_DELETE_ITEM: (state, item = {}) => {
    state.checkedDeleteItem = item
  },

  // modal remove confirmation

  OPEN_REMOVE_CONFIRMATION (state) {
    state.removeConfirmation.active = true
  },

  CLOSE_REMOVE_CONFIRMATION (state) {
    state.removeConfirmation.active = false
  },

  // reset store
  RESET_STORE: (state) => {
    state.allItemsChecked = false
    state.list = []
    state.currentItem = {}

    // query params
    // state.search = ''
    state.sort = {}
    // state.filter = {}
    state.pagination.perPage = 10
    state.pagination.currentPage = 1

    // response modal
    state.modalResponse.isActive = false
    state.modalResponse.title = ''
    state.modalResponse.text = ''

    // modal Item Is Used
    state.modalItemIsUsed.isActive = false
    state.modalItemIsUsed.text = ''

    // remove confirmation
    state.removeConfirmation.active = false
  }
})

const createActions = () => ({
  ...vuexBase.createActions(),

  async deleteItems ({ state, commit, dispatch, getters }) {
    commit('CLOSE_REMOVE_CONFIRMATION')

    const checkedItems = []
    const errorItems = []
    const usedItems = []

    state.list.forEach(item => {
      if (item.isActive) {
        commit('SET_CHECKED_DELETE_ITEM', item)

        if (getters.itemIsUsed) {
          usedItems.push(item)
        } else {
          checkedItems.push(item)
        }
      }
    })

    commit('SET_CHECKED_DELETE_ITEM')

    if (usedItems.length) {
      commit('OPEN_MODAL_ITEM_IS_USED', setErrorString(usedItems, state.deleteResponseKey))
    }

    for (const item of checkedItems) {
      try {
        await deleteItem(state.urlApi, item.id)
      } catch (e) {
        errorItems.push(item)
        console.log('Ошибка удаления ', e)
      }
    }

    state.allItemsChecked = false
    commit('SET_CURRENT_PAGE', 1)
    await dispatch('loadList')

    if (errorItems.length) {
      commit('OPEN_MODAL_RESPONSE', {
        text: `При удалении записей произошла ошибка: ${setErrorString(errorItems, state.deleteResponseKey)}`,
        title: 'Ошибка!'
      })
    }

    if (!errorItems.length && checkedItems.length) {
      commit('OPEN_MODAL_RESPONSE', {
        text: 'Записи удалены',
        title: 'Успех!'
      })
    }
  }
})

const vuexLogistic = {
  createState,
  createGetters,
  createMutations,
  createActions
}

export {
  vuexLogistic
}
